

import styles from './ButtonMain.module.css'

function ButtonMain({onclickfunc, txt}){
    return(<button className={styles.btn} onClick={onclickfunc} >{txt}</button>)
}

export default ButtonMain